// YouTube制作: ページ遷移後にスタジオメニュードロワーを閉じる
const closeCreatorAppMenu = () => {
  const toggle = document.getElementById("member-app-menu")
  if (toggle) toggle.checked = false
}

document.addEventListener("turbolinks:load", closeCreatorAppMenu)
